import type { FC } from 'react'

import { Error404 } from '../error'

import { LayoutNavigation } from './LayoutNavigation'

interface LayoutNavigationError404Props {
  showContextMenuButton?: boolean
}

export const LayoutNavigationError404: FC<LayoutNavigationError404Props> = ({ showContextMenuButton }) => {
  return (
    <LayoutNavigation showContextMenuButton={showContextMenuButton} stretchContentVertically>
      <Error404 />
    </LayoutNavigation>
  )
}
